import { SourcingSharedChooseChannelStep } from 'modules/sourcing-shared/shared-steps';
import { useShallow } from 'zustand/react/shallow';
import { useSourcingInternalStore } from 'modules/sourcing-internal/stores/hooks';
import { getSourcingInternalHeaderBreadcrumbs } from 'modules/sourcing-internal/utils';

export const SourcingInternalChooseChannelStep = () => {
  const {
    candidateBatch,
    channelFormData,
    onChooseChannelNext,
    onChooseChannelBack,
    setStep
  } = useSourcingInternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      channelFormData: state.channelFormData,
      onChooseChannelNext: state.onChooseChannelNext,
      onChooseChannelBack: state.onChooseChannelBack,
      setStep: state.setStep
    }))
  );

  return (
    <SourcingSharedChooseChannelStep
      headerBreadcrumbs={getSourcingInternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch?.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch?.id ?? '',
        setStep
      })}
      defaultFormData={channelFormData}
      onChooseChannelNext={onChooseChannelNext}
      onHeaderBack={onChooseChannelBack}
    />
  );
};
